export const zigTags = {
	title: "Administrar Zig Tags",
	table: {
		columns: {
			zigCode: "Zig Code",
			userName: "Usuario",
			userDocument: "Documento del usuario",
			isBlocked: "¿Está bloqueada?",
			actions: "Acciones",
		},
		actions: {
			blockTag: "Bloquear Tag",
		},
	},
	form: {
		label: "Buscar Zig Tag",
		placeholder: "Ingrese el número de la tag",
		searchBtn: "Buscar",
		errors: {
			zigTagRequired: "Ingrese el número de la tag para buscar",
		},
	},
	empty: {
		title: "Busque una zig tag para administrarla",
	},
	block: {
		success: "Tag bloqueada con éxito",
	},
};
